// removed by extract-text-webpack-plugin
module.exports = {"pagination":"pagination","pagination__prev":"pagination__prev","pagination__next":"pagination__next","svg-icon":"svg-icon","disabled":"disabled","pagination__content":"pagination__content","pagination__current-page":"pagination__current-page"};


//////////////////
// WEBPACK FOOTER
// ../css/components/_pagination.scss
// module id = 91
// module chunks = 0